// @ts-check

import {
  GET_ADDRESS,
  CREATE_ADDRESS,
  UPDATE_ADDRESS,
  DELETE_ADDRESS,
  GET_USER_VISIBLE_COLUMNS
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const changeLogFeatureFlag = (
  /** @type {{ currentAccountFeatureFlags: { changelog: any; }; }} */ state
) => {
  return state.currentAccountFeatureFlags.changelog;
};

export const getAddressesStatus = (
  /** @type {{ status: { [x: string]: any; }; }} */ state
) => state.status[getActionStatusName(GET_ADDRESS)] || {};
export const createAddressStatus = (
  /** @type {{ status: { [x: string]: any; }; }} */ state
) => state.status[getActionStatusName(CREATE_ADDRESS)] || {};
export const updateAddressStatus = (
  /** @type {{ status: { [x: string]: any; }; }} */ state
) => state.status[getActionStatusName(UPDATE_ADDRESS)] || {};
export const deleteAddressStatus = (
  /** @type {{ status: { [x: string]: any; }; }} */ state
) => state.status[getActionStatusName(DELETE_ADDRESS)] || {};
export const getUserVisibleColumnsStatus = (
  /** @type {{ status: { [x: string]: any; }; }} */ state
) => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
export const formattedRowData = (
  /** @type {typeof import('.').default.state} */ state
) =>
  state.addresses.map(addr => {
    return ({
      id: addr.id,
      name: addr.name,
      countryCode: addr.countryCode,
      countryName: addr.countryName,
      businessName: addr.customerName,
      addressCombined: `${addr.streetAddress}, ${addr.city} ${addr.postalCode}`,
    });
  });
